<template>
    <div class="noticeDialog">
        <el-dialog class="noticeDialogBox acBox" append-to-body :title="title" :visible="dialogVisible" width="800px" height="600px" @close="noticeDialogChange" :close-on-click-modal="false" >
            <div class="dialogContent">
                <div class="noticeDialogItem clear" v-for="item in noticeDialogListData" :key="item.id" @click="openNotice(item)">
                    <span class="fl title more_text1">{{item.title}}</span>
                    <span class="fr time">{{item.publishAt | diffDate}}</span>
                </div>
            </div>
            <div slot="footer">
                <table-pagination class="pagination" :pageTotal="pageData.total" @handlePageChange='handlePageChange'></table-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import home from '@/services/home';
export default {
    props: ['categoryId', 'title'],
    data() {
        return {
            dialogVisible: true,
            noticeDialogListData: [],
            pageData: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.getDialogNotice()
    },
    methods: {
        getDialogNotice() {
            home.getMessage({categoryId: this.categoryId, ...this.pageData}).then(res => {
                this.noticeDialogListData = res.result.data
                this.pageData.total = res.result.total
            })
        },
        noticeDialogChange() {
            this.$emit('close')
        },
        handlePageChange(val) {
            this.pageData.pageNumber = val;
            this.getDialogNotice()
        },
        openNotice(item) {
            window.open(item.urlLink)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body{
    padding: 0;
    min-height: 448px
}
::v-deep .el-dialog__footer{
    padding: 0
}
::v-deep .pagination{
    margin: 0
}
.dialogContent{
    height: 500px;
}
.noticeDialogItem{
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    padding: 0 24px;
    cursor: pointer;
    .title{
        color: #1C1C1E;
        max-width: 552px;
        display: inline-block
    }
    .time{
        color: #999;
    }
}
.noticeDialogItem:nth-child(2n-1) {
    background-color: #F4F5F7
}
.pagination{
    text-align: center;
    padding: 12px 0;
}
</style>
